module.exports = __webpack_public_path__ + "static/media/maxilofacial.85c268ed.png";